import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2dfd4aa6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.scss?vue&type=style&index=0&id=2dfd4aa6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd4aa6",
  null
  
)

export default component.exports